// RCM library API — cross-section: CUECs uses it for the mapping multi-select,
// the shell uses it for the read-only library view.
import { api } from "./client";
import type { RcmControl } from "./types";

export async function listRcmControls(): Promise<RcmControl[]> {
  const data = await api.get<{ rcm_controls: RcmControl[] }>(`/rcm-controls`);
  return data.rcm_controls;
}

/** #127: set a control's in-scope System tag (used for system-specific CUEC matching). */
export async function updateRcmControl(id: string, system: string | null): Promise<RcmControl> {
  const data = await api.patch<{ rcm_control: RcmControl }>(`/rcm-controls/${id}`, { system });
  return data.rcm_control;
}
